import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, ListIcon, PlusIcon, UsersIcon, MenuIcon } from './icons';

interface NavItem {
  to: string;
  label: string;
  icon: React.ReactNode;
  highlight?: boolean;
  action?: 'menu';
  tour?: string;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Home', icon: <HomeIcon />, tour: 'mobile-nav-home' },
  { to: '/practice', label: 'Sessions', icon: <ListIcon />, tour: 'mobile-nav-sessions' },
  {
    to: '/practice/new',
    label: 'New',
    icon: <PlusIcon />,
    highlight: true,
    tour: 'mobile-nav-new',
  },
  { to: '/personas', label: 'Personas', icon: <UsersIcon />, tour: 'mobile-nav-personas' },
  {
    to: '',
    label: 'More',
    action: 'menu',
    icon: <MenuIcon className="w-6 h-6" />,
    tour: 'mobile-nav-more',
  },
];

interface MobileBottomNavProps {
  onOpenMenu?: () => void;
}

export function MobileBottomNav({ onOpenMenu }: MobileBottomNavProps) {
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    if (!to) return false;
    return location.pathname.startsWith(to);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 md:hidden z-40 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-1">
        {NAV_ITEMS.map((item) => {
          const active = isActive(item.to);

          if (item.highlight) {
            return (
              <Link
                key={item.label}
                to={item.to}
                className="flex flex-col items-center justify-center -mt-4"
                data-tour={item.tour}
              >
                <div className="w-12 h-12 rounded-full bg-green-700 text-white flex items-center justify-center shadow-lg">
                  {item.icon}
                </div>
                <span className="text-[10px] font-medium text-green-700 mt-0.5">{item.label}</span>
              </Link>
            );
          }

          if (item.action === 'menu') {
            return (
              <button
                key={item.label}
                type="button"
                onClick={onOpenMenu}
                className="flex flex-col items-center justify-center flex-1 py-1 text-gray-500"
                data-tour={item.tour}
              >
                {item.icon}
                <span className="text-[10px] mt-0.5 font-medium">{item.label}</span>
              </button>
            );
          }

          return (
            <Link
              key={item.label}
              to={item.to}
              className={`flex flex-col items-center justify-center flex-1 py-1 ${
                active ? 'text-green-700' : 'text-gray-500'
              }`}
              data-tour={item.tour}
            >
              {item.icon}
              <span className={`text-[10px] mt-0.5 ${active ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
